import classNames from "classnames";

import { ReactComponent as IconDonation } from "../../assets/ic-donation.svg";
import { ReactComponent as IconPromoter } from "../../assets/ic-promoter.svg";

import styles from "./index.module.scss";

const CreatorsBadges = ({
  isSupporter,
  isTopSupporter,
  isPromoter,
  isTopPromoter,
}) => {
  const badges = [];

  if (isSupporter)
    badges.push(
      <IconDonation
        key="supporterBadge"
        className={classNames(
          styles.icon,
          styles.supporter,
          isTopSupporter && styles.top,
        )}
      />,
    );

  if (isPromoter)
    badges.push(
      <IconPromoter
        key="promoterBadge"
        className={classNames(
          styles.icon,
          styles.promoter,
          isTopPromoter && styles.top,
        )}
      />,
    );

  return badges;
};

export default CreatorsBadges;
